module.exports = __webpack_public_path__ + "static/media/ic_upload_blue.ed3dc1fb.svg";